import Plot from "react-plotly.js";
import React, {useEffect, useState} from "react";

const Plotly3D = (props) => {
  const [lineDataA, setLineDataA] = useState({x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'red'}, name: 'Sensor X', type: 'scatter3d', mode: 'lines+markers'});
  const [lineDataB, setLineDataB] = useState({x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'green'}, name: 'Sensor Y', type: 'scatter3d', mode: 'lines+markers'});
  const [lineDataC, setLineDataC] = useState({x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'blue'}, name: 'Sensor Z', type: 'scatter3d', mode: 'lines+markers'});
  const [markers, setMarkers] = useState([]);
  const [globalMin, setGlobalMin] = useState(0);
  const [globalMax, setGlobalMax] = useState(1000);

  const [maxX, setMaxX] = useState(0);
  const [minX, setMinX] = useState(0);
  const [maxY, setMaxY] = useState(0);
  const [minY, setMinY] = useState(0);
  const [maxZ, setMaxZ] = useState(0)
  const [minZ, setMinZ] = useState(0)

  useEffect(() => {
    const processSensorData = (sensorData) => {
      const radar = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};
      const camera = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};
      const imu = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};
      const antenna = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};
      const lidar = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};
      const ultrasonics = {x: [], y: [], z: [], dx_a: [], dy_a: [], dz_a: [], dx_b: [], dy_b: [], dz_b: [], dx_c: [], dy_c: [], dz_c: []};

      for (let sensorType in sensorData) {
        for (let sensorLocation in sensorData[sensorType]) {
          const data = sensorData[sensorType][sensorLocation];
          const _x = data?.origin_point_x;
          const _y = data?.origin_point_y;
          const _z = data?.origin_point_z;
          const _dx_a = data?.dx_a;
          const _dy_a = data?.dy_a;
          const _dz_a = data?.dz_a;
          const _dx_b = data?.dx_b;
          const _dy_b = data?.dy_b;
          const _dz_b = data?.dz_b;
          const _dx_c = data?.dx_c;
          const _dy_c = data?.dy_c;
          const _dz_c = data?.dz_c;

          if (_x != null && _y != null && _z != null) {
            if (sensorType === 'Radar') {
              radar.x.push(_x);
              radar.y.push(_y);
              radar.z.push(_z);
              radar.dx_a.push(_dx_a);
              radar.dy_a.push(_dy_a);
              radar.dz_a.push(_dz_a);
              radar.dx_b.push(_dx_b);
              radar.dy_b.push(_dy_b);
              radar.dz_b.push(_dz_b);
              radar.dx_c.push(_dx_c);
              radar.dy_c.push(_dy_c);
              radar.dz_c.push(_dz_c);
            } else if (sensorType === 'Camera') {
              camera.x.push(_x);
              camera.y.push(_y);
              camera.z.push(_z);
              camera.dx_a.push(_dx_a);
              camera.dy_a.push(_dy_a);
              camera.dz_a.push(_dz_a);
              camera.dx_b.push(_dx_b);
              camera.dy_b.push(_dy_b);
              camera.dz_b.push(_dz_b);
              camera.dx_c.push(_dx_c);
              camera.dy_c.push(_dy_c);
              camera.dz_c.push(_dz_c);
            } else if (sensorType === 'IMU') {
              imu.x.push(_x);
              imu.y.push(_y);
              imu.z.push(_z);
              imu.dx_a.push(_dx_a);
              imu.dy_a.push(_dy_a);
              imu.dz_a.push(_dz_a);
              imu.dx_b.push(_dx_b);
              imu.dy_b.push(_dy_b);
              imu.dz_b.push(_dz_b);
              imu.dx_c.push(_dx_c);
              imu.dy_c.push(_dy_c);
              imu.dz_c.push(_dz_c);
            } else if (sensorType === 'Antenna') {
              antenna.x.push(_x);
              antenna.y.push(_y);
              antenna.z.push(_z);
              antenna.dx_a.push(_dx_a);
              antenna.dy_a.push(_dy_a);
              antenna.dz_a.push(_dz_a);
              antenna.dx_b.push(_dx_b);
              antenna.dy_b.push(_dy_b);
              antenna.dz_b.push(_dz_b);
              antenna.dx_c.push(_dx_c);
              antenna.dy_c.push(_dy_c);
              antenna.dz_c.push(_dz_c);
            } else if (sensorType === 'Lidar') {
              lidar.x.push(_x);
              lidar.y.push(_y);
              lidar.z.push(_z);
              lidar.dx_a.push(_dx_a);
              lidar.dy_a.push(_dy_a);
              lidar.dz_a.push(_dz_a);
              lidar.dx_b.push(_dx_b);
              lidar.dy_b.push(_dy_b);
              lidar.dz_b.push(_dz_b);
              lidar.dx_c.push(_dx_c);
              lidar.dy_c.push(_dy_c);
              lidar.dz_c.push(_dz_c);
            } else if (sensorType === 'Ultrasonic') {
              ultrasonics.x.push(_x);
              ultrasonics.y.push(_y);
              ultrasonics.z.push(_z);
              ultrasonics.dx_a.push(_dx_a);
              ultrasonics.dy_a.push(_dy_a);
              ultrasonics.dz_a.push(_dz_a);
              ultrasonics.dx_b.push(_dx_b);
              ultrasonics.dy_b.push(_dy_b);
              ultrasonics.dz_b.push(_dz_b);
              ultrasonics.dx_c.push(_dx_c);
              ultrasonics.dy_c.push(_dy_c);
              ultrasonics.dz_c.push(_dz_c);
            }
          }
        }
      }

      return {radar, camera, imu, antenna, lidar, ultrasonics};
    };

    const sensorsDataMap = props?.plotlyTraces;
    const {radar, camera, imu, antenna, lidar, ultrasonics} = processSensorData(sensorsDataMap);

    const allX = [...radar.x, ...camera.x, ...imu.x, ...antenna.x, ...lidar.x, ...ultrasonics.x];
    const allY = [...radar.y, ...camera.y, ...imu.y, ...antenna.y, ...lidar.y, ...ultrasonics.y];
    const allZ = [...radar.z, ...camera.z, ...imu.z, ...antenna.z, ...lidar.z, ...ultrasonics.z];

    // set min and max for each axis.
    let absMaxX = -Infinity;
    let absMaxY = -Infinity;
    let absMaxZ = -Infinity;
    let absMinX = Infinity;
    let absMinY = Infinity;
    let absMinZ = Infinity;
    for (let i = 0; i < allX.length; i++) {
      if (allX[i] > absMaxX) absMaxX = allX[i];
      if (allX[i] < absMinX) absMinX = allX[i];
      if (allY[i] > absMaxY) absMaxY = allY[i];
      if (allY[i] < absMinY) absMinY = allY[i];
      if (allZ[i] > absMaxZ) absMaxZ = allZ[i];
      if (allZ[i] < absMinZ) absMinZ = allZ[i];
    }
    const buffer = 1000;
    setMaxX(absMaxX + buffer);
    setMinX(absMinX - buffer);
    setMaxY(absMaxY + buffer);
    setMinY(absMinY - buffer);
    setMaxZ(absMaxZ + buffer);
    setMinZ(absMinZ - buffer);


    const allDX_A = [...radar.dx_a, ...camera.dx_a, ...imu.dx_a, ...antenna.dx_a, ...lidar.dx_a, ...ultrasonics.dx_a];
    const allDY_A = [...radar.dy_a, ...camera.dy_a, ...imu.dy_a, ...antenna.dy_a, ...lidar.dy_a, ...ultrasonics.dy_a];
    const allDZ_A = [...radar.dz_a, ...camera.dz_a, ...imu.dz_a, ...antenna.dz_a, ...lidar.dz_a, ...ultrasonics.dz_a];
    const allDX_B = [...radar.dx_b, ...camera.dx_b, ...imu.dx_b, ...antenna.dx_b, ...lidar.dx_b, ...ultrasonics.dx_b];
    const allDY_B = [...radar.dy_b, ...camera.dy_b, ...imu.dy_b, ...antenna.dy_b, ...lidar.dy_b, ...ultrasonics.dy_b];
    const allDZ_B = [...radar.dz_b, ...camera.dz_b, ...imu.dz_b, ...antenna.dz_b, ...lidar.dz_b, ...ultrasonics.dz_b];
    const allDX_C = [...radar.dx_c, ...camera.dx_c, ...imu.dx_c, ...antenna.dx_c, ...lidar.dx_c, ...ultrasonics.dx_c];
    const allDY_C = [...radar.dy_c, ...camera.dy_c, ...imu.dy_c, ...antenna.dy_c, ...lidar.dy_c, ...ultrasonics.dy_c];
    const allDZ_C = [...radar.dz_c, ...camera.dz_c, ...imu.dz_c, ...antenna.dz_c, ...lidar.dz_c, ...ultrasonics.dz_c];

    const lineDataAMarkerSize = [];
    const lineDataBMarkerSize = [];
    const lineDataCMarkerSize = [];

    const _lineDataA = {x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'red'}, name: 'Sensor X', type: 'scatter3d', mode: 'lines+markers'};
    const _lineDataB = {x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'green'}, name: 'Sensor Y', type: 'scatter3d', mode: 'lines+markers'};
    const _lineDataC = {x: [], y: [], z: [], marker: {size: []}, line: {shape: 'linear', color: 'blue'}, name: 'Sensor Z', type: 'scatter3d', mode: 'lines+markers'};
    for (let i = 0; i < allX.length; i++) {
      // A
      _lineDataA.x.push(allX[i], allDX_A[i], null);
      _lineDataA.y.push(allY[i], allDY_A[i], null);
      _lineDataA.z.push(allZ[i], allDZ_A[i], null);
      lineDataAMarkerSize.push(10, null, null);
      // B
      _lineDataB.x.push(allX[i], allDX_B[i], null);
      _lineDataB.y.push(allY[i], allDY_B[i], null);
      _lineDataB.z.push(allZ[i], allDZ_B[i], null);
      lineDataBMarkerSize.push(10, null, null);
      // C
      _lineDataC.x.push(allX[i], allDX_C[i], null);
      _lineDataC.y.push(allY[i], allDY_C[i], null);
      _lineDataC.z.push(allZ[i], allDZ_C[i], null);
      lineDataCMarkerSize.push(10, null, null);
    }

    setLineDataA({..._lineDataA, marker: {size: lineDataAMarkerSize}});
    setLineDataB({..._lineDataB, marker: {size: lineDataBMarkerSize}});
    setLineDataC({..._lineDataC, marker: {size: lineDataCMarkerSize}});

    const markerSize = 8;
    const markerData = [
      {type: 'scatter3d', mode: 'markers', x: radar.x, y: radar.y, z: radar.z, marker: {size: markerSize, color: 'rgb(245,177,29)', symbol: 'triangle'}, name: 'Radar'},
      {type: 'scatter3d', mode: 'markers', x: camera.x, y: camera.y, z: camera.z, marker: {size: markerSize, color: 'rgb(111,8,138)'}, name: 'Camera'},
      {type: 'scatter3d', mode: 'markers', x: lidar.x, y: lidar.y, z: lidar.z, marker: {size: markerSize, color: 'red'}, name: 'Lidar'},
      {type: 'scatter3d', mode: 'markers', x: ultrasonics.x, y: ultrasonics.y, z: ultrasonics.z, marker: {size: markerSize, color: 'brown'}, name: 'Ultrasonics'},
      {type: 'scatter3d', mode: 'markers', x: imu.x, y: imu.y, z: imu.z, marker: {size: markerSize, color: 'green'}, name: 'IMU'},
      {type: 'scatter3d', mode: 'markers', x: antenna.x, y: antenna.y, z: antenna.z, marker: {size: markerSize, color: 'blue'}, name: 'Antenna'}
    ];

    setMarkers(markerData);
  }, [props]);

  // const globalMin = 0
  // const globalMax = 1000

  const layout = {
    uirevision: 'true',
    autosize: false,
    width: 800,  // Set your desired width
    height: 500, // Set your desired height
    scene: {
      // title: '3D View',
      aspectmode: 'manual',
      camera: {
        eye: {x: 2, y: 2, z: 2} // Adjust these values to zoom out
      },
      xaxis: {
        fixedrange: true,
        title: 'X Axis (mm)',
        rangemode: "normal",
        range: [minX, maxX],
        autorange: false
      },
      yaxis: {
        fixedrange: true,
        title: 'Y Axis (mm)',
        rangemode: "normal",
        range: [minY, maxY],
        autorange: false

      },
      zaxis: {
        fixedrange: true,
        title: 'Z Axis (mm)',
        rangemode: "normal",
        range: [minZ, maxZ],
        autorange: false
      },
    },
    margin: {
      l: 0,
      r: 0,
      b: 0,
      t: 0,
    },
    legend: {
      orientation: 'h',
      y: .9,

      // x: 1,
      // y: 0.5,
      // yanchor: 'middle',
      // pad: {t: 10}
    },
  };

  if (props?.plotlyTraces == null) return null;
  return (
    <Plot
      data={[...markers, lineDataA, lineDataB, lineDataC]}
      style={{height: 500, width: 800}}
      layout={layout}
      useResizeHandler={true}
      config={null}
    />
  );
};

export default Plotly3D;